// ----------------------
// Cookie Utility Section
// ----------------------

const REDIRECT_COOKIE = "geoRedirectURI";

function getCookie(name) {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="))
    ?.split("=")[1];
}

function setSessionCookie(name, value) {
  const domain = ".atyabalmarshoud.com"; // Shared across subdomains
  const oneDayFromNow = new Date(
    Date.now() + 7 * 24 * 60 * 60 * 1000
  ).toUTCString(); // 7 days
  document.cookie = `${name}=${value}; path=/; domain=${domain}; expires=${oneDayFromNow}`;
}

function deleteCookie(name) {
  const domain = ".atyabalmarshoud.com";
  document.cookie = `${name}=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
}

// --------------------------
// Geo-Redirect Logic Section
// --------------------------

const redirectCountries = {
  QA: "https://qa.atyabalmarshoud.com/en-qa",
  AE: "https://uae.atyabalmarshoud.com/en-ae",
  KW: "https://www.atyabalmarshoud.com/",
  WW: "https://www.atyabalmarshoud.com/",
  SA:"https://ksa.atyabalmarshoud.com/en-ksa"
};

(async function () {
  // Already redirected? — skip
  const cookie = getCookie(REDIRECT_COOKIE);
  if (cookie) return;

  const currentDomain = window.location.hostname;

  // Shopify theme editor — skip
  if (window.Shopify && window.Shopify.designMode) return;

  // Bot detection — skip
  const isBot = /bot|crawl|spider|slurp|mediapartners/i.test(
    navigator.userAgent
  );
  if (isBot) return;

  // Call Geo API
  fetch(
    window.Shopify.routes.root +
      "browsing_context_suggestions.json" +
      "?country[enabled]=true" +
      `&country[exclude]=${window.Shopify.country}` +
      "&language[enabled]=true" +
      `&language[exclude]=${window.Shopify.language}`
  )
    .then((res) => res.json())
    .then((data) => {
      const countryCode = data?.detected_values?.country?.handle?.toUpperCase();
      const redirectUrl = redirectCountries?.[countryCode] ?? redirectCountries.WW;
      if (!redirectUrl) return;

      const targetHost = new URL(redirectUrl)?.hostname;
      if (!currentDomain.includes(targetHost)) {
        setSessionCookie(REDIRECT_COOKIE, redirectUrl);
        window.location.href = redirectUrl;
      }
    })
    .catch((err) => {
      console.error("Geo redirect failed:", err);
    });
})();
